import { FormControl, FormHelperText, Stack } from '@mui/material';
import React from 'react';
import { Controller, FieldValues, useFormContext } from 'react-hook-form';

import { Alert } from '@/shared/components/ui/alert/alert';
import { FormLabel } from '@/shared/components/ui/form/components/form-label/form-label';
import { TFormToggleProps } from '@/shared/components/ui/form/components/form-toggle/form-toggle.types';
import { Toggle } from '@/shared/components/ui/form/components/toggle/toggle';

export const FormToggle = <TFieldValues extends FieldValues>({
  name,
  leftLabel,
  rightLabel,
  disabled = false,
  required = false,
  helperText,
  label,
  defaultValue,
  hint,
  onChange,
  ...rest
}: TFormToggleProps<TFieldValues>) => {
  const { control } = useFormContext<TFieldValues>();

  return (
    <Controller
      name={name}
      control={control}
      defaultValue={defaultValue}
      render={({
        field: { onChange: onFieldChange, ...field },
        fieldState,
      }) => (
        <FormControl error={!!fieldState.error} required={required}>
          {label && <FormLabel label={label} required={true} />}
          <Stack gap="0.75rem">
            <Toggle
              checked={!!field.value}
              disabled={disabled}
              leftLabel={leftLabel}
              rightLabel={rightLabel}
              {...field}
              {...rest}
              onChange={(event, value) => {
                onFieldChange(value);
                onChange?.(event, value);
              }}
            />

            {(fieldState.error?.message || helperText) && (
              <FormHelperText>
                {fieldState.error?.message || helperText}
              </FormHelperText>
            )}
            {hint && <Alert color="blue" text={hint} />}
          </Stack>
        </FormControl>
      )}
    />
  );
};
